var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumber1Xl = function SvgNumber1Xl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Checkliste",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 203.5 327.12"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.42,324.12H39.71c-8.64,0-10.08-.96-10.08-10.08v-36.96c0-9.12,1.44-9.6,10.08-9.6h43.2V90.36l-46.08,25.44c-7.2,3.84-8.64,3.84-12.96-3.36l-17.76-30.24c-4.32-7.2-4.8-8.16,2.88-13.44L104.98,3h42.72c9.12,0,9.6,1.92,9.6,10.08v254.4h33.12c9.12,0,10.08.48,10.08,9.6v36.96c0,9.12-.96,10.08-10.08,10.08Z"
  })));
};
export { SvgNumber1Xl as ReactComponent };